// src/components/dashboard/MessageBoardWidget.js
// Shared across every dashboard that shows a Message Board card (Employee,
// Company/Department/Master/Super Admin) — not Trainer/Vendor, which are
// excluded from the whole feature. Wraps DashboardCard directly rather than
// StatTile, since StatTile has no room for a "View Messages" link.
import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import axios from 'axios';
import DashboardCard from './DashboardCard';

const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;

function MessageBoardWidget() {
  const [count, setCount] = useState(0);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    axios.get(`${API_BASE_URL}/messages/get_unread_message_count.php`, { withCredentials: true })
      .then(response => setCount(response.data.count || 0))
      .catch(error => console.error('Error fetching unread message count:', error))
      .finally(() => setLoading(false));
  }, []);

  return (
    <DashboardCard title="Message Board" icon="bi-megaphone" loading={loading}>
      <div className="text-center">
        <h2 className="mb-1">{count}</h2>
        <div className="text-muted small mb-2">Unread {count === 1 ? 'message' : 'messages'}</div>
        <Link to="/messages">View Messages</Link>
      </div>
    </DashboardCard>
  );
}

export default MessageBoardWidget;
